import IComponent from "components/commons/IComponent";
import "./Views.css";
import MapUI from "./MapUI";
import SceneView from "@arcgis/core/views/SceneView";
import MapView from "@arcgis/core/views/MapView";

import LegendPanel from "./LegendPanel";
import DialogPanel from "components/DialogPanel";
import ElevationProfile from "components/ElevationProfile/ElevationProfile";

import IdentifyManager from "./IdentifyManager";
import { addAvailableLayers } from "./AddLayers";

import ReactDOM from "react-dom";
import ShortcutLayerList from "./ShortcutLayerList";
import New3DListPanel from "components/LayerSetting/New3DLayerSetting/New3DListPanel";

import { LoadPortalLayers } from "../MapViews/LoadPortalLayers";
import GetArcGISToken from "utils/GetArcGISToken";

import QuickView from "./QuickView";
import DownloadFromWebAPI from "utils/DownloadFromWebAPI";

import Mode3DQueue from "./Mode3DQueue";
import AerialPhoto from "components/AerialPhoto/AerialPhoto";
let forceElevationOff = false;
class ViewUI extends IComponent {
  layerListName = null;
  constructor(props) {
    super(props);
    this.viewContainer = this.createRef();
    this.state = {
      view: null,
      showLegendPanel: false,
      showDialogPanel: false,
      show3DElevation: false,
      dialogPanelTitle: null,
      shortcutContainer: null,
      layer3DPanelContainer: null,
    };
    this.layerListName = `mapList${props.splitMap ? "2" : ""}`;
  }
  componentDidMount() {
    this.initialGisData();
  }
  createNewView() {
    this.state.view && this.destroyObjects();
    const is3DView = this.props.mapType == 3;
    const viewClass = is3DView ? SceneView : MapView;
    // const mapClass = is3DView ? WebScene : WebMap;
    const view = new viewClass({
      container: this.viewContainer.current,
      map: [],
      qualityProfile: "high",
      ui: { components: [] },
      extent: this.$config.FULL_EXTENT,
    });
    // TODO: This one should be removed in production envrionemnt
    window.mapView = view;

    // console.log(mediaLayer)

    if (is3DView) {
      view.map.ground["navigationConstraint"] = {
        type: "none",
      };
    }

    addAvailableLayers.apply(this, [view, is3DView]).then(() => {
      this.props.onMapCreatedCallback && this.props.onMapCreatedCallback(view);
      this.props.showDialog({
        isOpen: false,
      });
    });

    if (!this.props.isCompactMode)
      view?.watch("camera", (nV, oV) => {
        // if (forceElevationOff || this.state.show3DElevation) return;
        if (forceElevationOff) return;
        let elevationV = Math.round(nV.tilt * 10);
        let eleLayer = view?.map?.allLayers.find((i) => i.type === "elevation");
        // elevation is flat
        // if (elevationV === 5 && !this.state.show3DElevation) {
        if (elevationV === 5) {
          eleLayer && (eleLayer.visible = false);
        } else {
          eleLayer && (eleLayer.visible = true);
        }
      });

    this.setState({ view, show3DElevation: false });

    if (!this.props.splitMap) {
      IdentifyManager.initialHook(view, this.props, this);
      MapUI.createUI(
        view,
        is3DView,
        this.mapUICallback.bind(this),
        this.props.isCompactMode
      );
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.mapType != this.props.mapType) this.initialGisData();
  }
  componentWillUnmount() {
    console.debug("Destroying MapView component");
    this.state.view && this.destroyObjects();
  }
  initialGisData() {
    this.props.showDialog({
      isOpen: true,
      title: "Loading",
      content: (
        <div>
          <span className="icn_loading" />
          Initializing GIS data, please wait...
        </div>
      ),
    });
    let vm = this;
    GetArcGISToken.waitForArcgisToken()
      .then(() => vm.props.mapType === 3 && LoadPortalLayers.loadPortalLayers())
      .then(() => this.createNewView())
      .then(() => vm.props.mapType === 3 && Mode3DQueue.registerPingTimer())
      .catch((e) => {
        console.debug(e);
        if (e.cause?.httpCode === 403)
          vm.props.showDialog({
            type: "error",
            isOpen: true,
            title: "Please log in",
            content:
              'You\'re not logged in. Click "OK" will redirect you to the authorize page',
            onDialogOk: () =>
              window.location.replace(this.$config.authorizePage),
          });
        else
          vm.props.showDialog({
            type: "error",
            isOpen: true,
            title: "Unable to initialize GIS data",
            content:
              "Unable to initialize GIS data. The application will not work without GIS data!",
            jsxElement: <div>{`${e.httpCode || ""} ${e.message}`}</div>,
          });
      });
  }
  async toggleViewMode(mode) {
    let result = await Mode3DQueue.ping();
    if (!result) {
      this.showNo3DModeMessage();
      return;
    }
    let promptMsg =
      mode == 3
        ? "Press OK to continue"
        : "Added 3D layers will be removed when switching view";
    let vm = this;
    this.props.showDialog({
      type: "prompt",
      isOpen: true,
      title: `Are you sure to switch to ${mode}D mode?`,
      content: promptMsg,
      onDialogOk: () =>
        setTimeout(() => {
          if (mode === 2) {
            Mode3DQueue.exit();
          }
          vm.props.typeToggle();
          vm.setState({
            show3DElevation: false,
            showDialogPanel: false,
            showLegendPanel: false,
          });
        }),
      onDialogCancel: () => {},
    });
  }
  showNo3DModeMessage() {
    this.props.showDialog({
      type: "error",
      isOpen: true,
      title: `3D mode is not available at the moment`,
      content:
        "Too many users are using 3D mode at the moment. Please try again later!",
      onDialogOk: () => {},
    });
  }
  mapUICallback(eventName, args) {
    switch (eventName) {
      case "switchMapModeTo3D":
        this.toggleViewMode(3);
        break;
      case "switchMapModeTo2D":
        this.toggleViewMode(2);
        break;
      case "splitScreen":
        this.props.switchPanel(4);
        this.mapUICallback("hideAllPanel");
        break;
      case "toggleLegend":
        this.setState({ showLegendPanel: !this.state.showLegendPanel });
        break;
      case "showBookmarkPanel":
        this.setState(
          {
            showDialogPanel: false,
          },
          () =>
            this.setState({
              showDialogPanel: true,
              dialogPanelTitle: "Bookmark",
            })
        );
        break;
      case "showRecorderPanel":
        this.setState(
          {
            showDialogPanel: false,
          },
          () =>
            this.setState({
              showDialogPanel: true,
              dialogPanelTitle: "Recorder",
            })
        );
        break;
      case "hideAllPanel":
        this.setState({ showDialogPanel: false });
        if (this.state.showPrinterPanel) {
          this.setState({ showPrinterPanel: false });
        }
        break;
      case "toggle3DElevation":
        this.props.switchPanel(-1);
        // let eleLayer1 = this.state.view?.map?.allLayers.find(
        //   (i) => i.type === "elevation"
        // );
        // eleLayer1 && (eleLayer1.visible = true);
        this.setState({ show3DElevation: !this.state.show3DElevation });
        this.setState({ showLegendPanel: false });
        break;
      case "toggleElevation":
        let elevationViewDiv = document.querySelector(
          ".esri-widget--button .icn_elevation"
        ).parentElement;
        forceElevationOff = !forceElevationOff;

        if (forceElevationOff) {
          elevationViewDiv.style.backgroundColor = "var(--uiColor3)";
        } else {
          elevationViewDiv.style.backgroundColor = "";
        }

        let eleLayer = this.state.view.map.allLayers.find(
          (i) => i.type === "elevation"
        );
        eleLayer.visible = !forceElevationOff;
        break;
      case "Printer":
        this.setState(
          {
            showDialogPanel: false,
          },
          () =>
            this.setState({
              showDialogPanel: true,
              dialogPanelTitle: "Printer",
            })
        );
        break;
      case "toggleShortcutPanel":
        this.setState({
          shortcutContainer: args.expandContainer,
        });
        break;
      case "toggle3DlayerPanel":
        this.setState({
          layer3DPanelContainer: args.expandContainer,
        });
        break;
      case "togglemail":
        this.setState(
          {
            showDialogPanel: false,
          },
          () =>
            this.setState({
              showDialogPanel: true,
              dialogPanelTitle: "Suggestion",
            })
        );
        break;
      case "toogleGoogleStreetView":
        this.setState(
          {
            showDialogPanel: false,
          },
          () =>
            this.setState({
              showDialogPanel: true,
              dialogPanelTitle: "GoogleStreetView",
            })
        );
        break;
      case "togglesummaryReport":
        window.open(DownloadFromWebAPI(this.$config.sis_summary));
        break;
      case "togglelastUpdatedDate":
        this.setState(
          {
            showDialogPanel: false,
          },
          () =>
            this.setState({
              showDialogPanel: true,
              dialogPanelTitle: "LastUpdatedDate",
            })
        );
        break;
      case "toggleArielPhoto":
        this.props.switchPanel(null, AerialPhoto);
        break;
    }
  }
  destroyObjects() {
    this.state.view.destroy();
    let list = this.$config[this.layerListName];
    Object.keys(list).forEach((i) => {
      let item = list[i];
      if (typeof item != "array") return;
      item.forEach(
        (i) => i.layer && i.layer.destroy && (i.layer.destroy(), delete i.layer)
      );
    });

    for (var key in list.layer3D) {
      list.layer3D[key].forEach((i) => {
        if (i.enabled && i.layer) i.layer.destroy();
      });
    }
    delete this.$config[this.layerListName];
  }
  render() {
    return (
      <div className="MapViewContainer">
        <div
          className={`ViewContainer${this.props.splitMap ? " SplitMap" : ""}`}
          ref={this.viewContainer}
        />
        {this.state.showDialogPanel &&
          ReactDOM.createPortal(
            <DialogPanel
              showDialog={this.props.showDialog}
              is3D={this.props.mapType == 3}
              mapView={this.state.view}
              title={this.state.dialogPanelTitle}
              mapUICallback={this.mapUICallback.bind(this)}
              reduxStore={this.props.reduxStore}
              reduxCallProxy={this.props.reduxCallProxy}
              enableResize={[
                "GoogleStreetView",
                "Bookmark",
                "Recorder",
                "Printer",
                "Suggestion",
                "LastUpdatedDate",
                // "Download",
                // "SpotElevations",
              ].includes(this.state.dialogPanelTitle)}
            />,
            document.querySelector(".MainPage")
          )}
        {this.state.showLegendPanel && (
          <LegendPanel
            is3D={this.props.mapType == 3}
            mapView={this.state.view}
            showSplitScreen={this.props.isSplitMapActivated}
          />
        )}
        {this.state.show3DElevation && (
          <ElevationProfile
            showDialog={this.props.showDialog}
            mapUICallback={this.mapUICallback.bind(this)}
            mapView={this.state.view}
          />
        )}
        {this.state.shortcutContainer &&
          ReactDOM.createPortal(
            <ShortcutLayerList
              mapType={this.props.mapType}
              is3D={this.props.mapType == 3}
              mapView={this.state.view}
              showDialog={this.props.showDialog}
            />,
            this.state.shortcutContainer
          )}
        {this.state.layer3DPanelContainer &&
          ReactDOM.createPortal(
            <New3DListPanel
              mapView={this.state.view}
              reduxStore={this.props.reduxStore}
              reduxCallProxy={this.props.reduxCallProxy}
              showDialog={this.props.showDialog}
            />,
            this.state.layer3DPanelContainer
          )}
        {this.state.view &&
          !this.props.splitMap &&
          ReactDOM.createPortal(
            <QuickView mapView={this.state.view} />,
            document.querySelector(
              ".ViewContainer:not(.SplitMap) .esri-ui-bottom-right"
            )
          )}
      </div>
    );
  }
}

export default ViewUI;
